import React, { useState, useEffect } from 'react';
import "./MainInvoiceReceipts.scss";
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import ReceiptRows from './ReceiptRows';
import { getPatientDetail, getPrintInvoiceDetailedById } from 'core/services/api';
import { calculateAge } from 'core/utils/date';


function MainInvoiceReceipts() {
  const [responseObj, setResponse] = useState<any>([])
  const [patientDetails, setPatientDetails] = useState<any>({})

  const history = useHistory()
  const location = useLocation();

  const patientId = location?.pathname?.split('/')[3]

  const getAllReceipts = async () => {
    try {
      const response = await getPrintInvoiceDetailedById(patientId, true)
      setResponse(response)
    } catch (error) {
      console.error(error)
    }
  }

  const getPatientDetails = async () => {
    try {
      const response = await getPatientDetail(patientId)
      setPatientDetails(response)
    } catch (error) {
      console.error(error)
    }

  }

  useEffect(() => {
    getAllReceipts()
    getPatientDetails()
  }, [patientId])

  return (
    <div className="receipt-main-page">
      <div className='left-element' >
        <div
          className="approval-back-image"
          onClick={() => {
            history.goBack()
          }}
        >
          <img
            src={"../../../../assets/images/back-icon.svg"}
            alt="back button"
            className="image-top-wrapper"
            style={{ height: "39px" }}
          />
        </div>
        <div className='Heading'>Receipts</div>

        <div className="wrapper">
          <div className="security-advance-container">
            <div className="subheading-payment">Patient ID:</div>
            <div className="subheading-value">
              {responseObj?.mocPatientId}
            </div>
            <div className="subheading-payment">Patient Name:</div>
            <div className="subheading-value">
              {responseObj?.patientName}
            </div>
          </div>
        </div>

      </div>
      <table className='pr-table-main'>
        <thead>
          <tr className='receipt-row-heading'>
            <th className='rs-date content-center'>Receipt Date</th>
            <th className='rs-id content-center'>Receipt Id</th>
            <th className='rs-invoice-id content-center'>Invoice Id</th>
            <th className='rs-services content-center'>Treatments
              & Products</th>
            <th className='rs-amount content-center'>Amount Paid</th>
            <th className='rs-mode-of-payment content-center'>Mode Of Payment</th>
            <th className='rs-minimalis-print content-center'>Print</th>
          </tr>
        </thead>
        <tbody>
          {responseObj?.receipts?.map((each: any) => {
            return (
              <ReceiptRows
                eachReceipt={each}
                patientName={responseObj?.patientName}
                mocPatientId={responseObj?.mocPatientId}
                patientAge={calculateAge(patientDetails?.dob)}
                patientGender={responseObj?.gender}
                primaryConsultant={responseObj?.primaryConsultantName}
                centerName={responseObj?.centerName}
                brandName={responseObj?.brandName}
                companyName={responseObj?.companyName}
                totalAdvanceAmount={responseObj?.totalAdvancePayment}
              />
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default MainInvoiceReceipts
